import { apiPost } from "./client";
import { apiGet } from "./client";
import { apiPut } from "./client";

export function login(payload) {
  return apiPost("/auth/login", payload);
}

export function register(payload) {
  return apiPost("/auth/register", payload);
}

export function verifyEmail(token) {
  const suffix = token ? `?token=${encodeURIComponent(token)}` : "";
  return apiGet(`/auth/verify-email${suffix}`);
}

export function getProfile() {
  return apiGet("/auth/profile");
}

export function updateProfile(payload) {
  return apiPut("/auth/profile", payload);
}

export function forgotPassword(email) {
  return apiPost("/auth/forgot-password", { email });
}

export function resetPassword(payload) {
  return apiPost("/auth/reset-password", payload);
}

export function changePassword(payload) {
  return apiPost("/auth/change-password", payload);
}
